import { useRef } from 'react';

import useQRCodeGenerator from 'react-hook-qrcode-svg';
import ReadMoreButton from "../../../../../components/UI/ReadMoreButton";

const QRCode = ({dados=null,title="sem nome"}) => {
    const QRCODE_LEVEL = 'L';
    const QRCODE_BORDER = 2;

    const svgRef = useRef(null);

    const { path, viewBox } = useQRCodeGenerator(
      `${btoa(JSON.stringify(dados))}`,
      QRCODE_LEVEL,
      QRCODE_BORDER
    );

    const compartilharImagem = async () => {
      const elementoSvg = svgRef.current;
      if (!elementoSvg) return;

      // 1. Verificação de segurança (Web Share API exige HTTPS no celular)
      if (!navigator.share) {
        alert("Seu navegador não suporta o compartilhamento nativo. Baixe a imagem.");
        return;
      }

      try {
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(elementoSvg);
        const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
        const blobURL = URL.createObjectURL(svgBlob);

        const img = new Image();
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
          img.src = blobURL;
        });

        const canvas = document.createElement('canvas');
        const rect = elementoSvg.getBoundingClientRect();
        const escala = 2; 
        canvas.width = (rect.width || img.width || 300) * escala;
        canvas.height = (rect.height || img.height || 150) * escala;
        
        const ctx = canvas.getContext('2d');
        ctx.scale(escala, escala);
        ctx.drawImage(img, 0, 0);
        URL.revokeObjectURL(blobURL);

        canvas.toBlob(async (blob) => {
          if (!blob) return;

          // 2. Transforma o blob em um arquivo real
          const arquivo = new File([blob], 'arte-criada.png', { type: 'image/png' });

          // 3. Verifica se o sistema aceita compartilhar esse tipo de arquivo
          if (navigator.canShare && navigator.canShare({ files: [arquivo] })) {
            await navigator.share({
              files: [arquivo] // Envia apenas o arquivo, deixando a legenda livre para o usuário digitar no app que escolher
            });
          } else {
            alert("Não é possível compartilhar arquivos neste navegador.");
          }
        }, 'image/png');

      } catch (err) {
        console.error('Erro ao compartilhar:', err);
      }
    };

    const salvarSvgComoImagem = async () => {
      const elementoSvg = svgRef.current;
      if (!elementoSvg) return;

      try {
        // 1. Converte o SVG para texto XML
        const serializer = new XMLSerializer();
        const svgString = serializer.serializeToString(elementoSvg);
        
        // 2. Cria o Blob do SVG e a URL temporária
        const svgBlob = new Blob([svgString], { type: 'image/svg+xml;charset=utf-8' });
        const blobURL = URL.createObjectURL(svgBlob);

        const img = new Image();
        
        // 3. Aguarda a imagem carregar o SVG
        await new Promise((resolve, reject) => {
          img.onload = resolve;
          img.onerror = reject;
          img.src = blobURL;
        });

        // 4. Desenha no Canvas para rasterizar o SVG em pixels (PNG)
        const canvas = document.createElement('canvas');
        const rect = elementoSvg.getBoundingClientRect();
        
        // Multiplica por 2 para a imagem não perder qualidade em telas Retina/Celulares
        const escala = 2; 
        canvas.width = (rect.width || img.width || 300) * escala;
        canvas.height = (rect.height || img.height || 150) * escala;
        
        const ctx = canvas.getContext('2d');
        ctx.scale(escala, escala);
        ctx.drawImage(img, 0, 0);
        
        // Libera a URL do SVG antigo
        URL.revokeObjectURL(blobURL);

        // 5. Transforma o Canvas em um arquivo PNG e força o download
        canvas.toBlob((blob) => {
          if (!blob) return;

          // Cria uma URL para o arquivo PNG final
          const urlDownload = URL.createObjectURL(blob);
          
          // Cria um link <a> virtual e invisível
          const link = document.createElement('a');
          link.href = urlDownload;
          link.download = `${title}-QRCODE.png`; // Nome do arquivo que será salvo
          
          // Adiciona ao documento, clica e remove (necessário para alguns navegadores mobile)
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          
          // Libera a memória da URL do PNG
          URL.revokeObjectURL(urlDownload);
        }, 'image/png');

      } catch (err) {
        console.error('Erro ao salvar a imagem:', err);
        alert('Não foi possível salvar a imagem.');
      }
    };

    return <>
      <svg
        ref={svgRef}
        width={200}
        height={200}
        viewBox={viewBox}
        stroke='none'
      >
      <rect width='100%' height='100%' fill='#ffffff' />
        <path d={path} fill='#000000' strokeWidth={0.1}/>
      </svg>
      <ReadMoreButton text="Compartilhar imagem do QR Code" onClick={()=>{
        compartilharImagem()}}/>
      <ReadMoreButton text="Salvar imagem do QR Code" onClick={()=>{
        salvarSvgComoImagem()}}/>
    </>
};

export default QRCode;